import React, { useState, useEffect } from 'react';
import { AsCheckbox } from '@adserve/adserve-react-components';
import { ReactComponent as DropdownArrow } from '../../svg/dropdown-triangle.svg';
import ScrollableContent from '../Scrolling/ScrollableContent';
const TreeView = ({ items, selectionChange, minRows, title, disabled, initialSelection }) => {
    const [selections, setSelections] = useState({});
    const [bottomSelections, setBottomSelections] = useState({});
    const [expansions, setExpansions] = useState({});
    const toggle = (e, item) => {
        if (disabled) return;
        if (e.target.checked) {
            if (!item.children?.length) {
                selections[item.id] = item;
            }
        } else {
            delete selections[item.id];
        }

        item.children?.map((a, b) => toggle(e, a));
    };
    useEffect(() => {
        if (initialSelection) {
            setSelections(initialSelection);
        }
    }, [initialSelection]);

    const toggleExpansion = (id) => {
        expansions[id] ? delete expansions[id] : (expansions[id] = true);
        setExpansions({ ...expansions });
    };
    const topToggle = (e, item) => {
        toggle(e, item);
        setSelections({ ...selections });
        if (selectionChange) selectionChange(Object.values(selections), Object.keys(selections));
    };
    const emptyRow = (rowCounter) => {
        const stripe = rowCounter.number % 2 === 0;
        const rowStyle = stripe
            ? { height: 29, backgroundColor: 'rgb(247,247,247)' }
            : { height: 29, backgroundColor: 'white' };
        rowCounter.number++;
        return (
            <tr key={`empty-${rowCounter.number}`} style={rowStyle}>
                <td style={{ width: 50 }}></td>
                <td style={{ width: 'calc(100% - 50px' }}></td>
            </tr>
        );
    };
    const isSelected = (item, level) => {
        let result = true;

        if (item.children?.length) {
            item.children.map((c, d) => {
                result = result && isSelected(c);
            });
        } else {
            result = selections[item.id];
        }
        return result;
    };

    const isPartial = (item, level) => {
        let result = false;

        if (item.children?.length) {
            item.children.map((c, d) => {
                result = result || isPartial(c);
            });
        } else {
            result = selections[item.id];
        }
        return result;
    };

    const allSelected = () => {
        let result = true;
        if (!items?.length) {
            result = false;
        }
        items.map((c, d) => {
            result = result && isSelected(c);
        });
        return result;
    };

    const selectAll = (e) => {
        items.map((item) => {
            toggle(e, item);
        });
        setSelections({ ...selections });
        if (selectionChange) selectionChange(Object.values(selections));
    };

    const showSelectAll = (rows, rowCounter) => {
        if (!items?.length) {
            return;
        }
        const rowStyle = { height: 29, backgroundColor: 'rgb(247,247,247)' };
        rows.push(
            <tr key={`empty-${rowCounter.number}`} style={rowStyle}>
                <td style={{ width: 50, textAlign: 'center' }}>
                    <AsCheckbox
                        checked={allSelected()}
                        onChange={(e) => selectAll(e)}
                        style={{ width: 14, height: 14 }}
                        disabled={disabled}
                    ></AsCheckbox>
                </td>
                <td>
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: 11 }}>&nbsp;</div>
                        <div>{window.translate('All Stations')}</div>
                    </div>
                </td>
            </tr>
        );
        rowCounter.number++;
    };

    const showLevel = (item, indent, rows, rowCounter) => {
        let expander = <div style={{ width: 40 }}></div>;
        if (item.children?.length) {
            expander = (
                <DropdownArrow
                    style={{
                        transform: `rotate(${expansions[item.id] ? 0 : 270}deg)`,
                        cursor: 'pointer',
                        padding: '0px 11px',
                        opacity: 1
                    }}
                    onClick={() => toggleExpansion(item.id)}
                />
            );
        }
        const stripe = rowCounter.number % 2 === 0;
        const rowStyle = stripe
            ? { height: 29, backgroundColor: 'rgb(247,247,247)' }
            : { height: 29, backgroundColor: 'white' };
        rows.push(
            <tr key={`data-${rowCounter.number}`} style={rowStyle}>
                <td
                    style={{
                        width: 50,
                        textAlign: 'center',
                        backgroundColor: isPartial(item, indent) ? 'rgb(207,255,207)' : rowStyle.backgroundColor
                    }}
                >
                    <AsCheckbox
                        checked={isSelected(item, indent)}
                        onChange={(e) => topToggle(e, item)}
                        style={{ width: 14, height: 14 }}
                        disabled={disabled}
                    ></AsCheckbox>
                </td>
                <td>
                    <div style={{ display: 'flex' }}>
                        <div
                            style={{
                                width: indent
                            }}
                        >
                            &nbsp;
                        </div>

                        {expander}
                        <div>{item.name}</div>
                    </div>
                </td>
            </tr>
        );

        if (expansions[item.id])
            item.children?.map((a, b) => {
                rowCounter.number++;
                showLevel(a, indent + 20, rows, rowCounter);
            });
    };
    const render = () => {
        const rows = [];
        const emptyRows = [];
        const rowCounter = { number: 0 };
        showSelectAll(rows, rowCounter);
        items.map((a, b) => {
            showLevel(a, 0, rows, rowCounter);
            rowCounter.number++;
        });
        const addEmpty = minRows && minRows > rowCounter.number;
        rowCounter.number = 0;
        if (addEmpty) {
            for (let i = 0; i < minRows; i++) {
                emptyRows.push(emptyRow(rowCounter));
            }
        }
        const headerStyle = {
            fontSize: 15,
            fontWeight: 500,
            color: 'rgb(65,65,65)',
            border: '1px solid rgb(215,215,215)'
        };
        return (
            <>
                <div style={{ display: 'flex' }}>
                    <div
                        style={{
                            height: 33,
                            width: '100%',
                            ...headerStyle,
                            verticalAlign: 'middle'
                        }}
                    >
                        <div style={{ marginTop: 7, marginLeft: 10 }}>{title}</div>
                    </div>
                </div>
                <ScrollableContent style={{ height: '100%' }}>
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            overflow: 'hidden',
                            width: '100%'
                        }}
                    >
                        <table
                            border={1}
                            style={{
                                borderCollapse: 'collapse',
                                border: '1px solid rgb(215,215,215)',
                                width: '100%',
                                fontSize: 12,
                                fontWeight: 500,
                                color: 'rgb(60,60,60)'
                            }}
                        >
                            <tbody>{emptyRows}</tbody>
                        </table>
                    </div>
                    <div style={{ zIndex: 200, position: 'relative' }}>
                        <table
                            border={1}
                            style={{
                                borderCollapse: 'collapse',
                                border: '1px solid rgb(215,215,215)',
                                width: '100%',
                                fontSize: 12,
                                fontWeight: 500,
                                color: 'rgb(60,60,60)'
                            }}
                        >
                            <tbody>{rows}</tbody>
                        </table>
                    </div>
                </ScrollableContent>
            </>
        );
    };
    return render();
};
export default TreeView;
